import { Auth, CookieStorage } from '@aws-amplify/auth'
import {
  CognitoIdentityProviderClient,
  ForgetDeviceCommand,
} from '@aws-sdk/client-cognito-identity-provider'
import { QueryClient } from '@tanstack/react-query'
declare global {
  interface Window {
    Cypress?: Cypress.Cypress
  }
}

export const cookieStorage = new CookieStorage({
  domain: (() => {
    if (window.location.origin.includes('rtml.localhost')) {
      return '.rtml.localhost'
    }
    if (window.location.origin.includes('localhost')) {
      return '.localhost'
    }
    return '.realtymogul.com'
  })(),
  path: '/',
  expires: 1,
  sameSite: 'strict',
  secure: !window.location.origin.includes('localhost'),
})

export const awsConfig = {
  Auth: {
    region: 'us-west-2',
    userPoolId:
      window.location.origin === 'https://my.realtymogul.com'
        ? `us-west-2_Z1cMSCXWl`
        : `us-west-2_iOmHSc6io`,
    userPoolWebClientId:
      window.location.origin === 'https://my.realtymogul.com'
        ? `715inci7q6uq2kpv3fdv9opknj`
        : `2iivupb66i0h6ng72dt0im61gp`,
    storage: cookieStorage,
  },
}

export const getUser = async () => {
  const cogUser = await Auth.currentAuthenticatedUser()
  return cogUser
}

export const cognitoLogout = () => {
  Auth.signOut()
}

const clearCookie = (name: string, domain?: string) => {
  const domainPart = domain ? `; domain=${domain}` : ''
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainPart}`
}

export const clearStoredAuthCookies = () => {
  const cognitoCookieNames = document.cookie
    .split(';')
    .map((cookie) => cookie.trim().split('=')[0])
    .filter((name) => name.startsWith('CognitoIdentityServiceProvider.'))

  for (const name of cognitoCookieNames) {
    clearCookie(name)
    clearCookie(name, window.location.hostname)

    if (window.location.hostname.includes('rtml.localhost')) {
      clearCookie(name, '.rtml.localhost')
    } else if (window.location.hostname.includes('localhost')) {
      clearCookie(name, '.localhost')
    } else {
      clearCookie(name, '.realtymogul.com')
    }

    cookieStorage.removeItem(name)
  }
}

export const fetchDevices = async () => {
  const devices = await Auth.fetchDevices()
  return devices
}

export const getAccessToken = async () => {
  const session = await Auth.currentSession()
  const accessToken = session.getAccessToken().getJwtToken()
  return accessToken
}

export const forgetDevice = async (
  accessToken: string,
  deviceKey: string,
  queryClient: QueryClient
) => {
  console.log(accessToken)
  try {
    const client = new CognitoIdentityProviderClient({
      region: 'us-west-2',
      // Add your credentials configuration here if needed
    })

    const command = new ForgetDeviceCommand({
      AccessToken: accessToken,
      DeviceKey: deviceKey,
    })

    await client.send(command)
    queryClient.invalidateQueries(['devices'])
    return true
  } catch (err) {
    console.log('some thing went wrong', err)
    throw err
  }
}
